import { IProviderForm, IProviderMutation } from 'services/providers/types';

export const providerFormToQuery = (
  values: IProviderForm
): IProviderMutation => ({
  ...values,
  salesChannels: values.salesChannels.map(channel => {
    const { name, ...salesChannel } = channel;
    return salesChannel;
  }),
});
